import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Form } from 'ui-base';
import styles from './Select.module.scss';

const { Select: BaseSelect } = Form;

class Select extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || props.defaultValue || ''
    };
  }

  static getDerivedStateFromProps(nextProps) {
    if (nextProps.value || nextProps.value === '') {
      return {
        value: nextProps.value
      };
    }
    return null;
  }

  onChange = event => {
    this.setState({
      value: event.target.value,
    });

    const { onChange } = this.props;
    if (onChange) onChange(event);
  };

  renderOptions = () => {
    const { options, children } = this.props;
    if (options.length) {
      return options.map(item => <option key={item.value} value={item.value}>{item.label}</option>);
    }
    return children;
  };

  render = () => {
    const { options, children, className, fullwidth, defaultValue, ...rest } = this.props;
    return (
      <BaseSelect
        className={classnames(styles.select, className, {
          'is-fullwidth': fullwidth
        })}
        {...rest}
        onChange={this.onChange}
        value={this.state.value}
      >
        {this.renderOptions()}
      </BaseSelect>
    );
  };
}

Select.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  fullwidth: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
      ]).isRequired
    })
  )
};

Select.defaultProps = {
  id: null,
  name: null,
  className: null,
  size: null,
  loading: false,
  disabled: false,
  fullwidth: false,
  options: [],
  children: null,
  onChange: null,
  value: null,
  defaultValue: null
};

export { Select };
